import * as React from 'react';
import { css, html } from 'react-strict-dom';

type Props = Readonly<{
  top?: boolean;
  bottom?: boolean;
  horizontal?: boolean;
  children: React.ReactNode;
}>;

export default function PageWrapPadding({
  top,
  bottom,
  horizontal,
  children,
}: Props) {
  return (
    <html.div
      style={[
        top && styles.top,
        bottom && styles.bottom,
        horizontal && styles.horizontal,
      ]}
    >
      {children}
    </html.div>
  );
}

const styles = css.create({
  top: {
    paddingTop: {
      default: 32,
      '@media (max-width: 768px)': 16,
    },
  },
  bottom: {
    paddingBottom: 150,
  },
  horizontal: {
    paddingInline: {
      default: 32,
      '@media (max-width: 768px)': 16,
    },
  },
});
